import { Phone, MapPin, Clock, CalendarX } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF, ADDRESS } from "@/data/site";
import { Reveal } from "./Reveal";

const isOpenNow = () => {
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Europe/Lisbon" })
  );
  const day = now.getDay();
  const mins = now.getHours() * 60 + now.getMinutes();
  const openDay = day >= 2 && day <= 6;
  const openHours = (mins >= 540 && mins < 780) || (mins >= 900 && mins < 1080);
  return openDay && openHours;
};

export const Contact = () => {
  const open = isOpenNow();

  return (
    <section id="contato" data-testid="contact-section" className="py-16 sm:py-24 lg:py-32 marble-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <p className="text-xs sm:text-sm font-medium tracking-[0.25em] uppercase text-[#C2185B]">
            Contato &amp; Localização
          </p>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-stone-900 max-w-2xl">
            Marcações e <em className="text-[#C2185B]">agendamentos</em>
          </h2>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-5">
            <div className="bg-[#C2185B] text-white rounded-3xl p-8 sm:p-10 h-full relative overflow-hidden">
              <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-white/10 blur-2xl pointer-events-none" />
              <p className="text-xs tracking-[0.25em] uppercase text-[#F8BBD0]">
                Para agendar, ligue
              </p>
              <a
                data-testid="contact-phone-link"
                href={PHONE_HREF}
                className="mt-4 block font-serif-display text-5xl sm:text-6xl font-semibold tracking-tight hover:text-[#F8BBD0] transition-colors duration-300"
              >
                {PHONE_DISPLAY}
              </a>
              <p className="mt-4 text-sm text-white/85 leading-relaxed max-w-xs">
                Toque no número em cima ou no botão em baixo para ligar
                diretamente do seu telemóvel.
              </p>
              <a
                data-testid="contact-cta-call"
                href={PHONE_HREF}
                className="mt-8 inline-flex items-center gap-3 bg-white text-[#C2185B] font-semibold px-7 py-4 rounded-full hover:bg-[#FFF0F5] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
              >
                <Phone size={17} strokeWidth={2.5} />
                Ligar Agora
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-3">
            <div className="bg-white rounded-3xl p-8 border border-rose-100 h-full flex flex-col">
              <div className="flex items-center justify-between">
                <Clock size={20} className="text-[#C2185B]" />
                <span
                  data-testid="business-hours-badge"
                  className={`text-xs font-semibold px-3 py-1.5 rounded-full ${
                    open
                      ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                      : "bg-rose-50 text-rose-700 border border-rose-200"
                  }`}
                >
                  {open ? "● Aberto agora" : "● Fechado agora"}
                </span>
              </div>
              <h3 className="mt-5 font-serif-display text-2xl font-semibold text-stone-900">
                Horário
              </h3>
              <div className="mt-4 space-y-3 text-sm">
                <div>
                  <p className="font-semibold text-stone-900">Terça a Sábado</p>
                  <p className="text-stone-600 mt-0.5">09:00 – 13:00</p>
                  <p className="text-stone-600">15:00 – 18:00</p>
                </div>
                <div className="pt-3 border-t border-rose-100 flex items-center gap-2 text-stone-500">
                  <CalendarX size={14} className="text-[#C2185B]" />
                  Fechado: Domingo e Segunda
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2} className="lg:col-span-4">
            <div className="bg-white rounded-3xl overflow-hidden border border-rose-100 h-full flex flex-col min-h-[320px]">
              <div className="p-6 flex items-start gap-3">
                <MapPin size={18} className="text-[#C2185B] mt-0.5 shrink-0" />
                <div>
                  <h3 className="font-serif-display text-xl font-semibold text-stone-900">
                    Onde Estamos
                  </h3>
                  <p data-testid="contact-address" className="text-sm text-stone-600 mt-1">
                    {ADDRESS}
                  </p>
                </div>
              </div>
              <iframe
                data-testid="location-map"
                title="Localização do Espaço da Beleza"
                src="https://www.google.com/maps?q=R.%2028%20de%20Setembro%206%2C%202625-159%20P%C3%B3voa%20de%20Santa%20Iria&output=embed"
                className="w-full flex-1 border-0 min-h-[220px]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
